export default __webpack_public_path__ + "static/media/late-icon.d72e51b2.svg";